<div [innerHTML]="content | trustHtml" class="ck-content whitespace-pre-wrap"></div>
